import React from "react";
import { X } from "lucide-react";

export type ClearAction = { label: string; onClear: () => void };

/** Keep reset separate from the trigger so both actions work with mouse and keyboard. */
export default function ClearableControl({
  children,
  clearAction,
  disabled = false,
}: {
  children: React.ReactNode;
  clearAction?: ClearAction;
  disabled?: boolean;
}) {
  if (!clearAction) return <>{children}</>;
  return (
    <div className="relative w-full [&>button:first-child]:w-full [&>button:first-child]:pr-10 [&>button:first-child]:border-info/30 [&>button:first-child]:bg-info/5 [&>button:first-child]:text-info">
      {children}
      <button
        type="button"
        aria-label={clearAction.label}
        title={clearAction.label}
        disabled={disabled}
        onClick={clearAction.onClear}
        className="absolute right-1 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-text-dim hover:bg-info/10 hover:text-text focus-visible:outline-info disabled:opacity-40"
      >
        <X aria-hidden="true" className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
